<mat-toolbar class="subtitulo">Familiar do Aluno</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <div ngModelGroup="comboFamiliar" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="40px">
                    <combo-pesquisavel #comboFamiliar 
                                       nome="familiar" 
                                       [itens]="comboFamiliares" 
                                       itemDescricao="nomeFamiliarAndNomeAluno"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       [obrigatorio]="false"
                                       placeholder="Informe o nome do familiar"
                                       [(valor)]="familiar">
                    </combo-pesquisavel>
                </div>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>
                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">
            <ng-container matColumnDef="familiar">
                <th mat-header-cell *matHeaderCellDef> Familiar </th>
                <td mat-cell *matCellDef="let element"> {{element.pessoasFisica.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="aluno">
                <th mat-header-cell *matHeaderCellDef> Aluno </th>
                <td mat-cell *matCellDef="let element"> {{element.aluno.pessoaFisica.nome}} </td>
            </ng-container>
    
            <ng-container matColumnDef="situacao">
                <th mat-header-cell *matHeaderCellDef> Situação  </th>
                <td mat-cell *matCellDef="let element"> {{situacaoParentesco.getSituacaoParentesco(element.situacaoParentesco)}} </td>
            </ng-container>

            <ng-container matColumnDef="tutela">
                    <th mat-header-cell *matHeaderCellDef> Tutela  </th>
                    <td mat-cell *matCellDef="let element"> {{isTutela(element)}} </td>
            </ng-container>
    
            <ng-container matColumnDef="transportaaluno">
                    <th mat-header-cell *matHeaderCellDef> Transporta o Aluno</th>
                    <td mat-cell *matCellDef="let element"> {{isTransportaAluno(element)}} </td>
            </ng-container>

            <ng-container matColumnDef="respfinanceiro">
                    <th mat-header-cell *matHeaderCellDef> Responsável Financeiro</th>
                    <td mat-cell *matCellDef="let element"> {{isResponsavelFinanceiro(element)}} </td>
            </ng-container>

            <ng-container matColumnDef="dataCadastro">
                <th mat-header-cell *matHeaderCellDef> Data Cadastro</th>
                <td mat-cell *matCellDef="let element"> {{element.dataCadastro | dataSimples}} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[40, 60, 80, 100, 200 ]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar novo familiar do aluno" mat-fab color="primary"
                    [routerLink]="['/familiaraluno/escolha']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
